import { Box } from '@mui/system';
import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import DebtorSelector from '../components/DebtorSelector';
import OfferteForm from '../components/OfferteForm';
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'

function OfferteFormBase() {
  const [partOneComplete, setPartOneComplete] = useState(false);
  const [selectedDebtor, setSelectedDebtor] = useState(null);

  return (
    <>
      <Container maxWidth="xl">
        <Box sx={{ minHeight: '800px' }}>
          <Box mt={2} mb={5}>
            <Typography variant="h1" color='secondary'>Offerteaanvraag</Typography>
          </Box>
          <DebtorSelector
            setPartOneComplete={setPartOneComplete}
            partOneComplete={partOneComplete}
            setSelectedDebtor={setSelectedDebtor}
          />
          {partOneComplete && selectedDebtor && <OfferteForm debtor={selectedDebtor} />}
          <Outlet />
        </Box>
      </Container>
    </>
  );
}

export default OfferteFormBase;
